// Visual compositions from Modelo html - Gass GroupV2, with the revised CMS contract.
// Field assignments are explicit: deleted CMS blocks are never recreated from static copy.
const standard = { eyebrow: 'iti_nome', heading: 'iti_resumo1', body: ['iti_descricao1'] };
const twoTexts = { eyebrow: 'iti_nome', heading: 'iti_descricao1', body: ['iti_descricao2'] };
const simple = { heading: 'iti_nome', body: [] };
const block = (type, main, list, fields = simple, options = {}) => ({
  type,
  main,
  list,
  ...fields,
  ...options,
});
const hero = (id) =>
  block('hero', id, null, { eyebrow: 'iti_nome', heading: 'iti_referencia', body: [] });
export const approvedLayouts = {
  home: [
    block('slider', 1),
    block('positioning', 2, null, { heading: 'iti_nome', body: ['iti_resumo1'] }),
    block('pillars', 3, 4, standard),
    block('approach', 5, 6, twoTexts),
    block('services', 7, 43, standard, { externalList: true, centered: true }),
    block('history', 8, null, {
      eyebrow: 'iti_nome',
      heading: 'iti_campoextra1',
      body: ['iti_resumo1'],
    }),
    block(
      'brands',
      9,
      10,
      { eyebrow: 'iti_nome', heading: 'iti_resumo1', body: [] },
      { centered: true },
    ),
    block('news', 11, 53, standard, { externalList: true, centered: true }),
    block('cta', 12, null, { eyebrow: 'iti_nome', heading: 'iti_descricao1', body: [] }),
  ],
  'o-grupo': [
    hero(17),
    block('split', 18, null, twoTexts),
    block('directory', 19, 20),
    block('reading', 21, 22, twoTexts, { listStyle: 'text' }),
    block('cards', 23, 24, { eyebrow: 'iti_nome', heading: 'iti_resumo1', body: [] }),
    block('cards', 25, 26),
  ],
  'nossa-historia': [
    hero(27),
    block('gallery', 28, null, {
      eyebrow: 'iti_referencia',
      heading: 'iti_nome',
      body: ['iti_resumo1', 'iti_descricao1'],
    }),
    block('reading', 29, null, twoTexts),
  ],
  proposito: [hero(30), block('reading', 31, null, twoTexts), block('text', null, 32)],
  'empresas-do-grupo': [
    hero(33),
    block('cards', 34, 35, { eyebrow: 'iti_nome', heading: 'iti_resumo1', body: [] }),
  ],
  governanca: [hero(36), block('reading', 37, 38, twoTexts, { listStyle: 'capabilities' })],
  'perguntas-frequentes': [hero(39), block('faq', null, 40)],
  solucoes: [
    hero(41),
    block('services', 42, 43, twoTexts, { centered: true }),
    block('reading', 44, null, twoTexts),
    block('reading', 45, null, twoTexts),
  ],
  setores: [
    hero(46),
    block('cards', 47, 48, { eyebrow: 'iti_nome', heading: 'iti_resumo1', body: [] }),
    block('directory', 49, 50),
  ],
  insights: [hero(51), block('news', 52, 53, standard, { centered: true })],
  contato: [
    hero(54),
    block('reading', 55, null, twoTexts),
    block('contact', 56, null, { eyebrow: 'iti_nome', heading: 'iti_resumo1', body: [] }),
    block('contactDirectory', 57, 58, { heading: 'iti_nome', body: ['iti_resumo1'] }),
  ],
  informacoes: [block('information', null, 59)],
};
